export default {
  name: 'channelOutput',
  data() {
    return {
      pageSize:8,
      pageIndex:1,
      total:0,
      addblogpop:false,
      rulepop:false,
      agreerule:false,
      loading:false,
      formValidate:{
        username:'',
        password:''
      },
      ruleValidate: {
        username: [
            { required: true, message: '微博账号不能为空', trigger: 'blur' }
        ],
        password: [
            { required: true, message: '密码不能为空', trigger: 'blur' }
        ]
      },
      list:[]
    }
  },
  watch:{
    addblogpop(bool){
      if(!bool){
        this.$refs['addBlogValidate'].resetFields();
      }
    }
  },
  computed:{
    type(){
      return this.$route.query.type;
    },
    pageCount(){
      return Math.ceil(this.total/this.pageSize);
    }
  },
  created() {
   this.getList();
  },
  mounted() {
	},
  methods: {
    showRule(){
      this.rulepop=true;
      this.agreerule=false;
    },
    ruleNext(){
      this.rulepop=false;
      this.addblogpop=true;
    },
    ruleCancel(){
       this.rulepop=false;
    },
    changePage(page){
      this.pageIndex=page;
      this.getList();
    },
    getList(){
      this.loading=true;
      this.$http.get('front/channel',{
        params:{
          pagesize:this.pageSize,
          pageindex:this.pageIndex-1,
          type:'SinaMicroBlog',
          ptype:this.type,
          audit:false
        }
      }).then((res)=>{
        // console.log(res);
        if(res.data.status == 1){
          this.loading=false;
          this.total=res.data.total;
          this.list=res.data.channels;
        }else{
          this.$Notice.error({title:res.data.message,desc:false});
        }
      },(error)=>{
        this.$Notice.success({title:error.data.message,desc:false});
      })
    },

//需要后台确认是不是添加了这个接口
  // addMicroblog(name){
  //       this.$refs[name].validate((valid) => {
  //           if (valid) {
  //             this.$http.get("/api/channel/get",{params:{channeltype:'SinaMicroBlog',username:this.formValidate.username}}).then((response) => {
  //                 if(response.data.status == 1){
  //                  if(response.data.newchannel == 'N'){
  //                     //更新
  //                     this.$Modal.confirm({
  //                       title: '确认提示',
  //                       content: '<p>该账号已存在，你确定要更新吗？</p>',
  //                       onOk: () => {
  //                         this.microAdd();
  //                       }
  //                     });
  //                  }else{
  //                     //添加
  //                     this.microAdd();
  //                  }
  //                 }else{
  //                   this.$Notice.error({
  //                     title: response.data.message,
  //                     desc: false
  //                   })
  //                 }
  //             },(error) => {
  //               this.$Notice.error({
  //                 title: error.data.message,
  //                 desc: false
  //               })
  //           })
  //         }
  //       })
  //   },
  //   microAdd(){
  //       this.$http.post('front/weibo/bind',{weiboName:this.formValidate.username,weiboPassword:this.formValidate.password,ptype:this.type}).then(res => {
  //         console.log(res);
  //         if (res.data.status == 1) {
  //             this.$Notice.success({title:res.data.message,desc:false});
  //           this.addblogpop=false;
  //           //获得列表
  //           this.getList();
  //         } else {
  //           this.addblogpop=false;
  //           this.$Notice.error({title:res.data.message,desc:false});
  //         }
  //       }, err => {
  //           this.$Notice.error({title:err.data.message,desc:false});
  //       })

  //   },

    addMicroblog(name){
        this.$refs[name].validate((valid) => {
            if (valid) {
               this.$http.post('front/weibo/bind',{weiboName:this.formValidate.username,weiboPassword:this.formValidate.password,ptype:this.type}).then(res => {
                // console.log(res);
                if (res.data.status == 1) {
                    this.$Notice.success({title:res.data.message,desc:false});
                  this.addblogpop=false;
                  //获得列表
                  this.getList();
                } else {
                  this.addblogpop=false;
                  this.$Notice.error({title:res.data.message,desc:false});
                }
              }, err => {
                  this.$Notice.error({title:err.data.message,desc:false});
              })

            }
        })
    },
    confirmPop(content,callback){
       this.$Modal.confirm({
        title: '确认提示',
        content: content,
        onOk: () => {
          callback();
        }
      });
    },
    unbind(id){
      this.$http.delete('front/channel/'+id).then((response)=>{
        if(response.data.status == 1){
           this.$Notice.success({title:response.data.message,desc:false});
           this.getList();
        }
      },(error)=>{
         this.$Notice.error({title:error.data.message,desc:false});
      })
    },
    unbindMicroblog(id){
      this.confirmPop('你确定要解绑该微博渠道吗？',()=>{this.unbind(id)});
    }
  }
}



// WEBPACK FOOTER //
// ./src/view/channel/microblogadd/index.js